import React from "react";
import { Button, Stack } from "@chakra-ui/react";
import { BUTTON_VARIANTS } from "@/theme/components/button";
import { scrollToElement } from "@/utils/scrollToElement";

const PricingFooter = () => {
  return (
    <Stack mt={2} spacing={8}>
      <Button
        variant={BUTTON_VARIANTS.IDEAL}
        onClick={() => scrollToElement("contact-us", 120)}
        mt={2}
        alignSelf={"center"}
        justifySelf={"center"}
      >
        Test Drive our VDI Solution
      </Button>
    </Stack>
  );
};

export default PricingFooter;
